export const Domain = 'zettavisor.com';
export const RememberMeExpires = 7;
